import { Model, attr } from '@elatonsev/js-models';

export default class TubeLineModel extends Model {
  name = attr('string');
  hex_color = attr('string');
}